(() => {
  if (window.arvoSiteReady) return;
  window.arvoSiteReady = true;
  const useUSMarket = () => {
    const form = document.querySelector('.av-us-market');
    if (!form) return;
    try {
      const lastAttempt = Number(sessionStorage.getItem('arvo_us_market_attempt') || 0);
      if (Date.now() - lastAttempt < 30000) return;
      sessionStorage.setItem('arvo_us_market_attempt', String(Date.now()));
    } catch { return; }
    const returnTo = form.querySelector('[name=return_to]');
    if (returnTo) returnTo.value = window.location.pathname + window.location.search + window.location.hash;
    form.requestSubmit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', useUSMarket, { once: true });
  else useUSMarket();
  document.addEventListener('click', async (event) => {
    const swatch = event.target.closest('[data-av-color]');
    if (swatch) {
      const visual = swatch.closest('.av-product-visual');
      const image = visual.querySelector('.av-product-img');
      if (!image) return;
      image.removeAttribute('srcset');
      image.src = swatch.dataset.src;
      image.alt = swatch.dataset.color;
      visual.querySelector('[data-av-color-name]').textContent = swatch.dataset.color;
      visual.querySelectorAll('[data-av-color]').forEach((button) => button.setAttribute('aria-pressed', String(button === swatch)));
    }
    const cartLink = event.target.closest('[data-av-cart]');
    if (!cartLink || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const api = window.essentialCartApi;
    if (!api || typeof api.openCart !== 'function') return;
    event.preventDefault();
    try {
      if (typeof api.refreshCart === 'function') await Promise.race([api.refreshCart(), new Promise((resolve) => setTimeout(resolve, 2000))]);
      api.openCart();
      setTimeout(() => {
        const portal = document.querySelector('#essential-cart-drawer-portal [role=dialog]');
        const visible = portal && portal.getClientRects().length > 0 && getComputedStyle(portal).visibility !== 'hidden';
        const opened = typeof api.isOpen === 'function' ? api.isOpen() : visible;
        if (!opened) window.location.assign(cartLink.href);
      }, 600);
    } catch { window.location.assign(cartLink.href); }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-av-disclosure][open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-av-disclosure][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('.av-nav-dropdown[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('essential-cart:update' , (event) => {
    const cart = event.detail?.cart || event.detail?.cartData || event.detail;
    if (!Number.isInteger(cart?.item_count)) return;
    document.querySelectorAll('[data-av-count]').forEach((count) => { count.textContent = cart.item_count; });
  });
})();
